import QwDateEditorials from '@qwentes/qw-date-editorials';

import * as countryList from 'country-list';

countryList.overwrite([{
  code: 'TW', name: 'Taiwan',
}]);

export default class CommunicationToolFilterModel {
  constructor(data = {}) {
    this.countries = this._generateCountries(data.countries);
    this.magazines = this._generateMagazines(data.magazines);
    this.dates = this._generateDates(data.dates);
  }

  _generateCountries(countries) {
    return countries
      .map(value => ({value, label: countryList.getName(value)}))
      .sort((a, b) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0));
  }

  _generateMagazines(magazines) {
    return magazines.map(mag => ({value: mag, label: mag}));
  }

  _generateDates(dates) {
    const formatted = dates.map(date => QwDateEditorials.formatMonthYear(date));
    const formattedDistinct = [...new Set(formatted)];
    const start = formattedDistinct[formattedDistinct.length - 1];
    const end = formattedDistinct[0];
    const rangeOfDates = (start && end) && QwDateEditorials.getRangeOfDates(start, end);
    return {
      original: dates,
      formatted: rangeOfDates && rangeOfDates.map(date => ({value: date, label: date})),
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/communication-tool/communication-tool-filter/communication-tool-filter.model.js